import {EvkOption} from "@evomatik/evk-common";
import {DiligenciaTareaModel} from "./diligencia-tarea.model";
import {RespuestaDocumentModel} from "./respuesta-document.model";
import {EstadoTareaDocumentModel} from "./estado-tarea-document.model";

export class TareaDocumentoModel{
    id: string;
    cargoTxt: string;
    cargoDestino: EvkOption;
    usuarioAsignado: EvkOption;
    tipoOrganizacion: EvkOption;
    organizacion: EvkOption;
    idNegocio: string;
    usuarioDelegado: string;
    tipoTarea: string;

    respuesta:RespuestaDocumentModel[];
    estadoTarea: EstadoTareaDocumentModel[];
    detalle: any;
    configuracion: any;
    tareaPadre:TareaDocumentoModel;
    tareaRespuestas:TareaDocumentoModel[];
    estadoTareaActivo: EstadoTareaDocumentModel;

    tieneTurnado: boolean;
    turnadoMultiple: boolean;

    diligencia: DiligenciaTareaModel;

    categoriaOrganizacion: EvkOption;
    contieneFormatosParaGenerar: boolean;

    createdBy: string;
    updatedBy: string;
    created: Date;
    updated: Date;
}
